const login_popup = {
    form: $('#popup-login-form'),
    error: $('#popup-login-form').find('.errors'),
    loading: $('#popup-login-form').find('.spinner-container'),
    modal: $('loginPopup'),
    hideLoadingState: () => {
        login_popup.loading.hide();
    },
    showLoadingState: () => {
        login_popup.loading.show();
    },
    serializeForm: (form) => {
        const formArray = form.serializeArray();
        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
            returnArray[formArray[i]['name']] = formArray[i]['value'];
        }
        return returnArray;
    },
    displayLoginError: () => {
        login_popup.error.empty();
        login_popup.error.show();
        let loginErrorMessage = window.theme.strings.loginErrorMsg;
        let errorHTML = `<p> ${loginErrorMessage.partOne} <a href=${loginErrorMessage.partLink}>${loginErrorMessage.partTwo}</a> ${loginErrorMessage.partThree} </p>`
        login_popup.error.append(errorHTML);
        dataLayerEvents.push({
            key: 'login',
            payload: {
                failed: {
                    reason: 'incorrect_credentials',
                    fields: 'password'
                }
            }
        });
    },
    checkFavourites: async () => {
        if (!window.favourites)
            return;
        const response = await window.favourites.sync();
        return response;
    },
    handleCheckLoginStatus: () => {
        $.ajax({
            url: '/?view=is_logged',
            method: 'GET',
            success: function (data) {
                var $data = $(data);
                var isLoggedIn = $data.filter('.is-logged__user').data('attr');
                if (isLoggedIn && isLoggedIn.trim() === "logged") {
                    if (window.location.pathname === '/cart') {
                        fetch("/cart/update").finally(async () => {
                            // Below line required to sync the localStorage and server favourites on login
                            await login_popup.checkFavourites();
                            window.location.href = '/pages/checkout?refresh=true';
                        });
                    } else {
                        // Check if the current page is in the prevent redirect list
                        const currentPath = window.location.pathname;
                        const preventRedirectPages = window.theme.settings.preventRedirect.pages;
                        const shouldPreventRedirect = preventRedirectPages.some(page => currentPath.includes(`/pages/${page.trim()}`));
                        if (shouldPreventRedirect) {
                            const loginPopup = document.querySelector('modal-popup#loginPopup');
                            if (loginPopup) {
                                loginPopup.hide();
                                document.dispatchEvent(new CustomEvent('loginAttempt'));
                            }
                            //  window.location.reload();
                        } else {
                            // Otherwise, proceed with the original redirect logic
                            fetch("/cart/update").finally(async () => {
                                // Below line required to sync the localStorage and server favourites on login
                                await login_popup.checkFavourites();
                                window.location.href = window.location.href + '/?logged-in=true';
                            });
                        }
                    }
                } else {
                    login_popup.displayLoginError();
                }
            },
            error: function () {
                console.error('Error getting login status.');
                login_popup.displayLoginError();
            },
            complete: function () {
                login_popup.hideLoadingState();
            }
        });
    },
    handleLoginCheck: () => {
        const login_data = login_popup.serializeForm(login_popup.form);
        login_data.form_type = "customer_login";
        login_data.utf8 = "✓";

        $.ajax({
            url: '/account/login',
            method: 'POST',
            data: login_popup.serializeForm(login_popup.form),
            dataType: 'html',
            beforeSend: function () {
                login_popup.error.hide();
            },
            success: function (data) {
                setTimeout(login_popup.handleCheckLoginStatus, 1200);
            },
            error: function (xhr, status, error) {
                console.error('AJAX Login Error:', error);
                window.location.href = '/';
                login_popup.hideLoadingState();
            }
        });

        if (document.body.getAttribute('data-customer-invitation')) {
            document.removeEventListener('login:checked', login_popup.handleLoginCheck, false);
        }
    },
    handleLoginValidation: (event) => {
        const event_detail = event.detail;
        login_popup.showLoadingState();

        if (event_detail.status) {
            if (document.body.getAttribute('data-customer-invitation')) {
                document.dispatchEvent(new CustomEvent('login:check', {
                    detail: {
                        form: "#popup-login-form",
                    }
                }))


                document.addEventListener('login:checked', login_popup.handleLoginCheck);
            } else {
                login_popup.handleLoginCheck();
            }
        }

        document.removeEventListener("form:validation", login_popup.handleLoginValidation, false);
    },
    handleLoginSubmit: (event) => {
        event.preventDefault();
        event.stopPropagation();

        document.addEventListener('form:validation', login_popup.handleLoginValidation);
    },
    init: () => {
        login_popup.form.on('submit', login_popup.handleLoginSubmit);
    }
}

login_popup.init();
